var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M16.5 10h-2.906l1.469-1.437C16 7.625 15.313 6 14 6h-2V2.5c0-.812-.687-1.5-1.5-1.5h-3A1.5 1.5 0 0 0 6 2.5V6H4C2.656 6 1.969 7.625 2.938 8.563L4.375 10H1.5A1.5 1.5 0 0 0 0 11.5v4c0 .844.656 1.5 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-4c0-.812-.687-1.5-1.5-1.5M4 7.5h3.5v-5h3v5H14l-5 5zm12.5 8h-15v-4h4.375l2.063 2.063a1.453 1.453 0 0 0 2.093 0l2.063-2.063H16.5zm-2.75-2c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75.74.74 0 0 0-.75.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgDownload;